/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneSpinner from 'base/components/standalone/Spinner';

export const DynamicStandaloneSpinner = StandaloneSpinner;
export type DynamicStandaloneSpinnerProps = PropsFromComponent<typeof StandaloneSpinner>;

export const DynamicStandaloneSpinnerWith = (extras: DynamicStandaloneExtras): typeof StandaloneSpinner => {
    return function DynamicStandaloneSpinner(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Spinner');
        return <StandaloneSpinner {...mergeProps({ options: { theme } }, props)} />;
    }
}